import { Models } from '../check-deposit-generated';
import CheckScanningPortalAccessInfo = Models.CheckScanningPortalAccessInfo;

/**
 * Utility functions for checking campus-specific access permissions
 */
export class CampusAccessUtils {
	/**
	 * Determines if a user can access the check scanning portal for a specific campus
	 */
	static canAccessCheckScanningPortalForCampus(
		checkScanningPortalAccess: CheckScanningPortalAccessInfo[],
		canAccessCheckScanningPortal: boolean,
		campusKey?: string
	): boolean {
		// If no campus key provided, fall back to general access
		if (!campusKey) {
			return canAccessCheckScanningPortal;
		}
		
		if (!checkScanningPortalAccess || checkScanningPortalAccess.length === 0) {
			return canAccessCheckScanningPortal;
		}

		return checkScanningPortalAccess.some(access => access.CampusKey === campusKey);
	}
}
